import { withLazy } from 'app/hocs/withLazy'

export const ProviderConditions = withLazy(
  () => import('features/Provider/components/ProviderConditions/ProviderConditions'),
)
